import { useGet, UseGetReturnType } from '../../../../api';
import { USER_MANAGEMENT_BASE_URL } from '../consts';
import { useMemo } from 'react';

interface GetLatestUserManagementUploadReportDto {
    latestProtectedUsersUploadFailureReportId: string;
    latestToken2UploadFailureReportId: string;
    latestProtectedUsersUploadFailureTimestamp: number;
    latestToken2UploadFailureReportTimestamp: number;
}

interface GetLatestUserManagementUploadReport {
    latestProtectedUsersUploadFailureReportId: string;
    latestToken2UploadFailureReportId: string;
    latestProtectedUsersUploadFailureTimestamp: number;
    latestToken2UploadFailureReportTimestamp: number;
}

type ReturnType = Omit<UseGetReturnType<unknown>, 'data'> & {
    latestUploadReport?: GetLatestUserManagementUploadReport;
};

const convertInsightsDtoToInsights = (
    data: GetLatestUserManagementUploadReportDto
): GetLatestUserManagementUploadReport => {
    return {
        latestProtectedUsersUploadFailureReportId: data.latestProtectedUsersUploadFailureReportId,
        latestToken2UploadFailureReportId: data.latestToken2UploadFailureReportId,
        latestProtectedUsersUploadFailureTimestamp: data.latestProtectedUsersUploadFailureTimestamp,
        latestToken2UploadFailureReportTimestamp: data.latestToken2UploadFailureReportTimestamp
    };
};

export const useGetLatestUploadReport = (): ReturnType => {
    const { data, ...restValues } = useGet<GetLatestUserManagementUploadReportDto>({
        url: `${USER_MANAGEMENT_BASE_URL}/latestUserManagementUploadReport`
    });

    const latestUploadReport = useMemo(() => {
        if (!data) {
            return undefined;
        }

        return convertInsightsDtoToInsights(data);
    }, [data]);

    return {
        ...restValues,
        latestUploadReport
    };
};
